import React, { Component } from 'react';
import locale from './locale';
import { browserHistory } from 'react-router'
import StudentInfoDock from 'template/Docks/StudentInfo';
import TeacherInfoDock from 'template/Docks/TeacherInfo';
import ContactInfoDock from 'template/Docks/ContactInfo';
import 'containers/Main/fontello-embedded.css'

import './ActivityLog.scss'

const TRANSLATED_FROM_DATA = {
  'edit': 'edited',
  'import': 'imported',
  'create': 'created',
  'delete': 'deleted',
  'remove': 'removed',
  'archive': 'archived',
  'add': 'added',
  'accept': 'accepted',
  'deny': 'denied',
  'publish': 'published',
  'unpublish': 'unpublished',
  'recover': 'recovered',
  'invite': 'invited',
  'convert': 'transfered',
  'teacher': 'teacher',
  'student': 'student',
  'class': 'class',
  'school': 'school',
  'poster': 'poster',
  'group': 'permission group',
  'group_list': 'permission group',
  'private_class': 'private class',
  'contact_notes': 'contact notes',
  'school_setting': 'terms and conditions',
  'student_custom_fields': 'student custom fields',
  'contact_custom_fields': 'contact custom fields',
  'record_charge': 'recorded a charge',
  'record_refund': 'recorded a refund',
  'initiate_charge': 'initiated a charge',
  'initiate_refund': 'initiated a refund',
  'student_task': 'planning task',
  'lesson': 'lesson',
  'lesson_list': 'lessons',
  'student_list': 'students',
  'trade_record_note': 'transaction remark with the receipt number',
  'contact_tag': 'contact tag',
  'contact': 'contact',
  'announcement': 'announcement',
  'classroom': 'classroom',
  'attendee': 'poster attendee'
}

const TRANSLATE_CONNECTING_WORD = {
  'create': 'for',
  'delete': 'from',
  'edit': 'in',
}

const TRANSLATE_CLASS_ARCHIVE = {
  'archive': 'closed',
}

class ActivityLog extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this)
    this.renderLog = this.renderLog.bind(this)
  }

  onClick(opts){
    return()=>{
      const {type, id} = opts
      switch(type){
        case 'school':
          browserHistory.push('/school-information');
          break
        case 'classroom':
          browserHistory.push('/classroom');
          break
        case 'announcement':
          browserHistory.push('/announcement');
          break
        case 'poster':
          browserHistory.push('/poster');
          break
        case 'group':
        case 'group_list':
          browserHistory.push('/school-settings');
          break
        case 'trade_record_note':
          browserHistory.push('/finance');
          break
        case 'contact_tag':
          browserHistory.push('/contacts');
          break
        case 'class':
          browserHistory.push(`/class-detail/${id}`);
          break
        case 'private_class':
          browserHistory.push(`/class-one-detail/${id}`);
          break
        case 'student':
        case 'trade_record':
        case 'student_task':
        case 'student_list':
          StudentInfoDock({id})
          break
        case 'contact':
        case 'contact_notes':
          ContactInfoDock({id})
          break
        case 'teacher':
          TeacherInfoDock({id})          
          break
        default:
          browserHistory.push('/');
      }
    }
  }

  renderLog(list){
    return(
      <div>
        {
          list.map((log) => {
            const {operator_name, log_context} = log
            const {
              object_type, 
              operation, 
              target_name_list, 
              object_name, 
              object_name_list, 
              object_id, 
              belong_to_name, 
              belong_to_id, 
              belong_to_type, 
              object_id_list, 
              target_type, 
              target_name
            } = log_context;
        
            switch(true){
              case object_type === 'class' && operation === 'add' :
                return(
                  <div>
                    <p>
                      <i className='icon-users'></i>
                      {(target_name_list.length > 1) ? __('{name} {operation} multiple students to {object_type}: ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      }) : __('{name} {operation} student {studentName} to {object_type}: ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        studentName: target_name_list.join(', '),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      })}
                      <a onClick={this.onClick({id: object_id, type: object_type})}>{object_name}</a>
                    </p>
                  </div>
                )
                break;
              
              case (object_type === 'student' || object_type === 'teacher') && operation === 'remove':
                return(
                  <div>
                    <p>
                      <i className='icon-book-reader'></i>
                      {__('{name} {operation} {object_type} {object_name} from {target_type} {target_name}', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                        object_name: object_name,
                        target_type: __(TRANSLATED_FROM_DATA[target_type], locale),
                        target_name: target_name,
                      })}
                    </p>
                  </div>
                )
                break;
        
              case object_type === 'invitation':
                return(
                  <div>
                    <p>
                      <i className='icon-mail-alt'></i>
                      {__('{name} {operation} {object_type}', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(object_type, locale),
                      })}
                    </p>
                  </div>
                )
                break;
        
              case object_type === 'contact_notes':
                return(
                  <div>
                    <p>
                      <i className='icon-perm_contact_calendar'></i>
                      {__('{name} {operation} {object_type} for ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      })}
                      <a onClick={this.onClick({id: belong_to_id, type: object_type})}>{belong_to_name}</a>
                    </p>
                  </div>
                )
                break;
        
              case object_type === 'school_setting': 
                return(
                  <div>
                    <p>
                      <i className='icon-cog'></i>
                      {__('{name} {operation} {object_type}', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_name], locale),
                      })}
                    </p>
                  </div>
                )
                break;
        
              case object_type === 'trade_record':
                return(
                  <div>
                    <p>
                      {(operation === 'record_charge' || operation === 'record_refund') && <i className='icon-assignment'></i>}
                      {(operation === 'initiate_charge' || operation === 'initiate_refund') && <i className='icon-money-bill'></i>}
                      {__('{name} {operation} for {belong_to_type} ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        belong_to_type: __(TRANSLATED_FROM_DATA[belong_to_type], locale),
                      })}
                      <a onClick={this.onClick({id: belong_to_id, type: object_type})}>{belong_to_name}</a>
                    </p>
                  </div>
                )
                break;
        
              case object_type === 'student_task' || object_type === 'lesson' || object_type === 'lesson_list':
                return(
                  <div>
                    <p>
                      {object_type === 'student_task' &&  <i className='icon-calendar-check-o'></i>}
                      {(object_type === 'lesson' || object_type === 'lesson_list') && <i className='icon-book'></i>}
                      {(object_type === 'lesson_list' && object_name_list.length > 1) ?  __('{name} {operation} multple {object_type} {connecting_word} {belong_to_type} ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                        connecting_word: TRANSLATE_CONNECTING_WORD[operation],
                        belong_to_type: __(TRANSLATED_FROM_DATA[belong_to_type], locale),
                      }) : __('{name} {operation} {object_type} {object_name} {connecting_word} {belong_to_type} ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: object_type === 'student_task' ? __(TRANSLATED_FROM_DATA[object_type], locale): '',
                        object_name: object_type === 'student_task' ? object_name : __('lesson', locale) + object_name_list,
                        connecting_word: TRANSLATE_CONNECTING_WORD[operation],
                        belong_to_type: __(TRANSLATED_FROM_DATA[belong_to_type], locale),
                      }) }
                      <a onClick={this.onClick({id: belong_to_id, type: belong_to_type})}>{belong_to_name}</a>
                    </p>
                  </div>
                )
                break;
              
              case (object_type === 'student' || object_type === 'teacher') && operation === 'archive':
                return (
                  <div>
                    <p>
                      {object_type === 'student' && <i className='icon-book-reader'></i>}
                      {object_type === 'teacher' && <i className='icon-chalkboard-teacher'></i>}
                      {__('{object_name} {operation} {object_type} ', locale, {
                        object_name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      })}
                      <a onClick={this.onClick({id: object_id, type: object_type})}>{object_name}</a>                          
                    </p>
                  </div>
                )
                break;
              
              case (object_type === 'class' || object_type === 'private_class') && operation === 'archive':
                return(
                  <div>
                    <p>
                      {object_type === 'class' && <i className='icon-users'></i>}
                      {object_type === 'private_class' && <i className='icon-user-friends'></i>}
                      {__('{object_name} {operation} {object_type} ', locale, {
                        object_name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATE_CLASS_ARCHIVE[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      })}
                      <a onClick={this.onClick({id: object_id, type: object_type})}>{object_name}</a>   
                    </p>
                  </div>
                )
                break;

              case object_type === 'student' && operation === 'import':
                return(
                 <div>
                    <p>
                      <i className='icon-book-reader'></i>
                      {__('{name} {operation} multiple {object_type} ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      })}
                    </p>
                 </div> 
                )
                break;
        
              case object_type === 'class' || object_type === 'private_class' || object_type === 'student' || object_type === 'teacher' ||
              object_type === 'classroom' || object_type === 'announcement' || object_type === 'contact' || object_type === 'contact_tag' ||
              object_type === 'trade_record_note' || object_type === 'group' || object_type === 'poster' ||
              object_type === 'school' || object_type === 'attendee':
                return(
                  <div>
                    <p>
                      {object_type === 'student' && <i className='icon-book-reader'></i>}
                      {object_type === 'teacher' && <i className='icon-chalkboard-teacher'></i>}
                      {object_type === 'announcement' && <i className='icon-megaphone'></i>}
                      {(object_type === 'contact' || object_type === 'contact_tag' || object_type === 'attendee') && <i className='icon-perm_contact_calendar'></i>}
                      {object_type === 'group' && <i className='icon-cog'></i>}
                      {object_type === 'poster' && <i className='icon-link-ext-alt'></i>}
                      {object_type === 'school' && <i className='icon-account_balance'></i>}
                      {object_type === 'classroom' && <i className='icon-chalkboard'></i>}
                      {object_type === 'class' && <i className='icon-users'></i>}
                      {object_type === 'private_class' && <i className='icon-user-friends'></i>}
                      {object_type === 'trade_record_note' && <i className='icon-assignment'></i>}
                      {__('{name} {operation} {object_type} ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      })}
                      { (operation !== 'convert' && operation !== 'delete') && <a onClick={this.onClick({id: object_id, type: object_type})}>{object_name}</a>}                       
                      { (operation === 'convert' || operation === 'delete') && <span>{object_name}</span>}                       
                    </p>
                  </div>
                )
                break;
              
              case object_type === 'group_list':
                return(
                  <div>
                    <p>
                      <i className='icon-cog'></i>
                      {__('{name} {operation} {object_type} ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      })}
                      <a onClick={this.onClick({id: object_id_list, type: object_type})}>{object_name_list}</a>
                      {__("'s member", locale)}  
                    </p>
                  </div>
                )
                break;

              case object_type === 'student_list' && operation === 'archive':
                return(
                  <div>
                    <p>
                      <i className='icon-book-reader'></i>
                      {object_name_list.length > 1 ? __('{object_name} {operation} multiple {object_type}', locale, {
                        object_name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      }) : __('{object_name} {operation} {object_type} ', locale, {
                        object_name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),                        
                      }) }
                      {object_name_list.length === 1 && <a onClick={this.onClick({id: object_id_list, type: object_type})}>{object_name_list}</a>}
                    </p>
                  </div>
                )
                break;
        
              case object_type === 'student_list':
                return(
                  <div>
                    <p>
                      <i className='icon-book-reader'></i>
                      {object_name_list.length > 1 ? __('{name} {operation} multiple {object_type} ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),
                      }) : __('{name} {operation} {object_type} ', locale, {
                        name: operator_name === 'Principal' ? __('Principal', locale) : operator_name,
                        operation: __(TRANSLATED_FROM_DATA[operation], locale),
                        object_type: __(TRANSLATED_FROM_DATA[object_type], locale),                        
                      }) }
                      {object_name_list.length === 1 && <a onClick={this.onClick({id: object_id_list, type: object_type})}>{object_name_list}</a>}
                    </p>
                  </div>
                )
                break;
        
              default:
                return (
                  <div style={{color: 'red'}}>ERROR!!!</div>
                )
            }
          })
        }
      </div>
    )
  }

  render() {
    const {resultList, hideTime = false} = this.props;

    return (
      <div className='activityLogContainer'>
      {Object.keys(resultList).map((date) => {

        let newLog = resultList[date]
        return(
          <div key={date} className='log-date-section'>
            {!hideTime && <h3>{date}</h3>}
            {Object.keys(newLog).map((time) => {
              return(
                <div className='log-min-section'>
                  {!hideTime && <span>{time}</span>}
                  {this.renderLog(newLog[time])}
                </div>
              )
            })}
          </div>
        )
      })}
      </div>
    );
  }
}

export default ActivityLog;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/ActivityLog/index.js